// Mock data and form submission handlers for LHSC website

export const mockFormSubmit = async (formType, data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`${formType} form submitted:`, data);
      resolve({
        success: true,
        message: `Thank you! Your ${formType} has been received.`,
        data: data
      });
    }, 800);
  });
};

export const mockMembers = {
  total: 1900,
  womenReached: 195000,
  citiesActivated: 25
};

export const mockTestimonials = [
  {
    id: 1,
    quote: "This association feels like home. The Lady Hustler Society Club has allowed me to create business opportunities while making long lasting friendships. A feel-good association with endless opportunities and support.",
    name: "Rasheeda Moodley",
    title: "Lady Hustler Member"
  },
  {
    id: 2,
    quote: "The community out here is like no other. Learning from the experts inside the weekly workshops has helped me improve in a lot of areas inside my business. The support you get -- starting from your mindset to your business -- is like no other.",
    name: "Poulomi Ghosh",
    title: "Lady Hustler Member & Board Member"
  },
  {
    id: 3,
    quote: "Thanks to these women and Ryma, I was able to make impact during challenging times -- a fundraiser for autism that raised $1,000 USD in 4 hours for autistic children affected by the Ukrainian war. I cannot imagine doing it without the support of my fellow Lady Hustlers.",
    name: "Mishka Sibert",
    title: "Lady Hustler Member & Board Advisor"
  }
];

export const mockMembershipTiers = [
  {
    id: 'sisterhood',
    name: 'The Sisterhood Starter',
    price: 14.95,
    annualPrice: 157.95,
    tagline: "A small step with a massive ripple. You\'re not just supporting a mission.",
    link: 'https://go.entrepreneurladyhustler.com/the-sisterhood-starter?_ga=2.52499616.94185788.1772608259-1083049351.1772608259'
  },
  {
    id: 'disruptor',
    name: 'The Committed Disruptor',
    price: 24.99,
    annualPrice: 269.95,
    tagline: "This is generosity as strategy. Power as service. Leadership as love.",
    link: 'https://go.entrepreneurladyhustler.com/the-committed-disruptor?_ga=2.52499616.94185788.1772608259-1083049351.1772608259'
  },
  {
    id: 'fighter',
    name: 'The Freedom Fighter',
    price: 49.99,
    annualPrice: 539.95,
    tagline: "You are the woman who carries the fire. You don\'t wait for permission to lead — you light the path and bring others with you.",
    link: 'https://go.entrepreneurladyhustler.com/the-freedom-fighter-3534?_ga=2.40868906.94185788.1772608259-1083049351.1772608259'
  }
];

export const mockCities = {
  phase1: ['Montreal', 'New York', 'London', 'Dubai', 'Cape Town'],
  phase2: ['Paris', 'Tunis', 'Mumbai', 'Bogota', 'Sydney'],
  phase3: ['Casablanca', 'Singapore', 'Sao Paulo', 'Berlin', 'Amman'],
  phase4: ['Amsterdam', 'Athens', 'Beirut', 'Mexico City', 'Stockholm', 'Lisbon', 'Buenos Aires', 'Brussels', 'Riyadh', 'Los Angeles']
};

export const mockUpcomingEvents = [
  {
    id: 1,
    title: 'Bi-Weekly Networking Mixer',
    date: 'January 15, 2026',
    type: 'In-Person & Virtual',
    description: 'Connect with female entrepreneurs and professionals at all stages.'
  },
  {
    id: 2,
    title: 'Clubhouse Audio Conference: Scaling Your Business',
    date: 'January 20, 2026',
    type: 'Audio Only',
    description: 'Join dynamic discussions with industry experts.'
  }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: 'Why Redistribution Matters More Than Charity',
    date: 'December 15, 2025',
    category: 'Impact',
    excerpt: 'Understanding the difference between giving and systemic change.'
  },
  {
    id: 2,
    title: 'Building a Business Without Burning Out',
    date: 'December 10, 2025',
    category: 'Entrepreneurship',
    excerpt: 'Sustainable growth strategies for women-led businesses.'
  },
  {
    id: 3,
    title: 'The Real Cost of Economic Inequality',
    date: 'December 5, 2025',
    category: 'Research',
    excerpt: 'Data-driven insights on women\'s economic empowerment.'
  }
];
